// Copyright (c) 2019 Deere & Company

import React, {PropTypes} from 'react';
import {Checkbox} from 'cap-it-ui.toggles';
import {FormattedMessage} from 'react-intl';

function handleChange() {

    this.onIncludeFullyCompleteInputChange(!this.includeFullyComplete);

}

const OpenPipProgramsIncludeFullyCompleteCriteria = props =>
    <section className='open-pips-include-fully-complete-criteria'>
        <div className='labeled-criteria form-group'>
            <h3 className='form-group-title optional-criteria'>
                <FormattedMessage id='INCLUDE_FULLY_COMPLETE'/>
            </h3>
            <Checkbox
                id='include-fully-complete'
                onChange={props::handleChange}
                selected={props.includeFullyComplete}
            >
            </Checkbox>
        </div>
    </section>;

OpenPipProgramsIncludeFullyCompleteCriteria.displayName = 'OpenPipProgramsIncludeFullyCompleteCriteria';
OpenPipProgramsIncludeFullyCompleteCriteria.propTypes = {
    includeFullyComplete: PropTypes.bool.isRequired,
    onIncludeFullyCompleteInputChange: PropTypes.func.isRequired
};

export default OpenPipProgramsIncludeFullyCompleteCriteria;




// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/components/open-pip-programs-include-fully-complete-criteria.js